import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { canUseDOM } from 'exenv';
// I don't think this ErrorMessage works but leaving it for now
// NOTE: Not seeing this working locally.  Updated all instances and still seeing the text-transform property on the element.
const LazyErrorMessage = React.lazy(
  () => import(/* webpackChunkName: "ErrorMessage" */ '@/components/error-message/ErrorMessage'),
);

export default class ErrorBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.element]),
  };

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  constructor() {
    super();
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== 'production') {
      const { error: logError, info: logInfo } = console;
      logError(error);
      logInfo(info);
    }

    const eventData = {
      error,
      info,
      message: error.message,
    };
    this.setState({ hasError: true });
    // NOTE - we have to do a story on fallback messaging if needed
    if (canUseDOM && window.newrelic && window.newrelic.addPageAction) {
      window.newrelic.addPageAction('jsErrorData', eventData);
    }
  }

  render() {
    if (this.state.hasError) {
      // Just show generic error message for now.
      return (
        <Suspense fallback={null}>
          <LazyErrorMessage
            error={{
              crcCode: 'checkout.error.default',
              message: 'Sorry, we had an issue with your request. Please try again.',
            }}
          />
        </Suspense>
      );
    }
    return this.props.children;
  }
}
